<!-- routify:options query-param-is-page=true -->
<script lang="ts">
  import ReferralsPage from "@shared/svelte/Components/Referrals/Page.svelte";
  import { params } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import * as _ from "lodash";

  const referralLeadsRes = async () => {
    try {
      let res = await HttpPromiseWithEntireResponse({
        method: "GET",
        url: "/api/retailer/referral_leads",
        data: {
          page: $params.page,
        },
      });
      let referralsRes;
      if (res.ok) {
        referralsRes = await res.json();
        referralsRes = { data: referralsRes };
        referralsRes.headers = function (h) {
          return res.headers.get(h);
        };
      }
      return referralsRes;
    } catch (e) {
      return [];
    }
  };

  const referralCodeRes = async () => {
    try {
      let res = await HttpPromise({
        method: "GET",
        url: "/api/retailer/referral_code",
      });
      return res;
    } catch (e) {
      return null;
    }
  };

  const load = async () => {
    const promises = [referralLeadsRes(), referralCodeRes()];

    let results = await Promise.all(promises);

    return {
      referralLeads: results[0],
      referralCode: { data: results[1] },
    };
  };

  $: stateParams = { page: $params.page };

</script>

{#key $params.page}
  {#await load()}
    <Spinner />
  {:then data}
    <ReferralsPage
      referralLeadsRes={data.referralLeads}
      referralCodeRes={data.referralCode}
      {stateParams}
      state={window["stateService"]}
    />
  {/await}
{/key}
